import { Messages } from "../../db";
import { upsertConversationMeta } from "../../db/ConversationMetadata.js";
import useConversationStore from "../../stores/ConversationStore";
import { createMessageObject } from "../../types/Message";
import { getSDK as getUnlinkSDK } from "../../sdk/UnlinkInstance";
import { loadLocalKeys } from "../../db/KeyStorageManager";
import bs58 from 'bs58';

/**
 * Handle and route a parsed chat message.
 * @param {Object} message
 * @param {string} message.messageId
 * @param {string} message.conversationId
 * @param {Object} message.parsed
 * @param {number} message.timestamp
 * @param {string} message.viewKey - public view key
 * @param {string} message.alias
 * @param {string} message.password - user's password (must be provided to decrypt later)
 */
export default async function dispatchParsedMedia({
  conversationId, 
  message,
  receiverIdentityViewPublicKey, 
  userId, 
  password, 
  salt,
}) {
  const timestamp = Date.now();
  const unlinkSdk = getUnlinkSDK();
  const unlinkKeys = await loadLocalKeys({ userId, password, salt });
  const { messageType, parsed, senderViewPublicKey } = message;

  // create message object
  const messageJSON = JSON.stringify(createMessageObject({
    message: {
      version: parsed.version,
      bytes: bs58.encode(parsed.bytes),
      mimeType: parsed.mimeType,
      fileName: parsed.fileName,
    },
    messageId: message.messageId,
    messageType,
    receiverViewPublicKey: bs58.encode(receiverIdentityViewPublicKey),
    senderViewPublicKey: bs58.encode(senderViewPublicKey),
    totalFeeLamports: message.totalFeeLamports,
    timestamp,
  }));

  // 1. Save the full message encrypted
  await Messages.storeEncryptedMessage({
    userId,
    conversationId: message.conversationId,
    messageJSON,
    timestamp,
    password,
  });

  // 2. Upsert into metadata table (conversation store)
  await upsertConversationMeta({
    conversationId: message.conversationId,
    lastMessage: messageJSON,
    lastMessageTimestamp: timestamp,
    participants: [message.senderViewPublicKey],
    senderViewPublicKey: message.senderViewPublicKey,
    userId,
    password,
  });
}